import { render, staticRenderFns } from "./AreaPOAEvFinal.vue?vue&type=template&id=1c4a7434"
import script from "./AreaPOAEvFinal.vue?vue&type=script&lang=js"
export * from "./AreaPOAEvFinal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports